import { useEffect, useState } from 'react';
import { fmtClock } from '../utils/fmt';
import StatusDot from './home/StatusDot';
import { CoinGeckoMark } from './home/HomeModule';
import './home/home.css';

/* Állapotpont a kártyák címe mellé (a régi „Forrás: X · frissítve hh:mm” sor
   helyett). A forrás és az idő a tooltipben van; szöveg csak késésnél vagy
   hibánál látszik.
     meta = { at, stale } — getFetchMeta() / az RSI-hook; több forrásnál mergeMeta()
     stale      → „késleltetett”: a hálózat nem válaszolt, a gyorsítótárból mutatjuk
     expectedMs → ha az adat ennek kétszeresénél régebbi, szintén „késleltetett”
     error      → „nem elérhető”
     note       → kézzel karbantartott adatnál (pl. naptár) az idő helyett */

function useNow(ms = 30000) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => { const t = setInterval(() => setNow(Date.now()), ms); return () => clearInterval(t); }, [ms]);
  return now;
}

export function sourceStatus({ meta, expectedMs, error, note, now = Date.now() }) {
  if (error) return 'error';
  if (meta?.stale) return 'delayed';
  if (meta?.at) return expectedMs && now - meta.at > 2 * expectedMs ? 'delayed' : 'fresh';
  return note ? 'static' : 'loading';
}

const HEAD = {
  fresh: 'Friss adat',
  delayed: 'Késleltetett: a vártnál régebbi adat',
  error: 'Az adatforrás most nem elérhető',
  loading: 'Betöltés…',
  static: 'Kézzel karbantartott adat',
};

export default function SourceDot({ source, meta, note, expectedMs, error }) {
  const now = useNow();
  const status = sourceStatus({ meta, expectedMs, error, note, now });
  const lines = [
    source && `Forrás: ${source}`,
    note,
    meta?.at && (meta.stale ? `Utolsó sikeres lekérés ${fmtClock(meta.at)}` : `Frissítve ${fmtClock(meta.at)}`),
  ];
  return (
    <span className="src-dot">
      <StatusDot status={status} label={HEAD[status]} lines={lines} />
      {status === 'delayed' && <span className="hm-late">késleltetett</span>}
      {status === 'error' && <span className="hm-late hm-late-err">nem elérhető</span>}
    </span>
  );
}

/* Apró, halvány név az adat alatt, ahol a szolgáltató ezt kéri
   (CoinGecko attribution guide, Alternative.me). */
export function SourceAttr({ cg, alt }) {
  return (
    <div className="hm-attr-row">
      {alt && <a className="hm-attr" href="https://alternative.me/crypto/fear-and-greed-index/" target="_blank" rel="noopener noreferrer" title="Fear & Greed Index: Alternative.me">Alternative.me</a>}
      {alt && cg && <span className="hm-attr" aria-hidden="true">&nbsp;·&nbsp;</span>}
      {cg && <CoinGeckoMark />}
    </div>
  );
}

/* Több forrás együtt: a legrégebbi időpont, és késleltetett, ha bármelyik az. */
export function mergeMeta(...metas) {
  const m = metas.filter(x => x && x.at);
  if (!m.length) return null;
  return { at: Math.min(...m.map(x => x.at)), stale: m.some(x => x.stale) };
}
